// src/data/industries.js
const Industries = [
  "Audiology",
  "Automotive",
  "Aviation",
  "Education and Training Institutions",
  "Financial Services and Accounting Firms",
  "Healthcare and Medical Practices",
  "Hospitality and Tourism",
  "Legal Firms",
  "Local Governments and Municipalities",
  "Manufacturing and Logistics",
  "Nonprofit Organizations",
  "Professional Services (Consulting, Marketing, HR)",
  "Real Estate and Property Management",
  "Retail and Ecommerce",
];

export default Industries;
